<template>
  <b-container>
    <b-button @click="createGroup">Create</b-button>
    <b-button @click="deleteGroup">Delete</b-button>
    <b-button @click="doIt">Do</b-button>
    <b-form-input v-model="groupUuid"/>

  </b-container>
</template>
<script>


export default {

  name: 'Test',
  components: {
  },
  props: {
    globalData: Object
  },

  data() {
    return {
      data: Object,
      groupUuid: '',
    }
  },
  created() {
  },
  destroyed() {
  }
  ,
  mounted() {
    // this.$refs.myCm.codemirror.highlight
  },
  methods: {

    doIt() {
      this.$http.get('/api/coros/publish')
          .then(response => {
            console.warn(response.data)
          })
          .catch(e => {
            console.warn(e)
          })
    },
    createGroup() {
      this.$http.post(`/api/groups/`, {
        name: 'Group Name',
        type: 'ORGANIZATION'
      })
          .then(() => {
            this.refresh();
          })
          .catch(e => {
            console.log(e);
          })
    },
    deleteGroup() {
      this.$http.delete(`/api/groups/${this.groupUuid}`,)
          .then(() => {
            this.refresh();
            this.groupUuid = ''
          })
          .catch(e => {
            console.log(e);
          })
    }
  }
}

</script>
<style scoped>

</style>
